'use client';

import { ReactNode } from 'react';

import { useTranslate } from '@/contexts/labels';
import { yup } from '@/lib/validation/yup';

import Form, { SubscribeDto } from './form';

export function SubscribeForm({
    children,
    onSubmit,
}: {
    children: ReactNode;
    onSubmit: (values: SubscribeDto) => Promise<void> | void;
}) {
    const errors = useTranslate('form.errors');

    const schema = Form.useSchema(() =>
        yup.object({
            firstName: yup.string().optional(),
            lastName: yup.string().optional(),
            email: yup
                .string()
                .email(errors('invalidEmail'))
                .required(errors('required')),
        })
    );

    return (
        <Form.Root
            className="gap-md flex flex-col items-stretch"
            schema={schema}
            onSubmit={onSubmit}
        >
            {children}
        </Form.Root>
    );
}
